export default {
    Locale: '_locale',
    Planer: '_planer',
};
